import React, { useEffect, useState } from 'react';
import GuildLogPicker from '../../components/GuildLogPicker';
import ConfirmDialog from '../../components/ConfirmDialog';
import WclQueryProgress from './WclQueryProgress';
import HeavyLogWarning from './HeavyLogWarning';
import { WclProgressSnapshot } from '../useWclProgress';
import { parseLogUrls } from '../utils';
import { heavyLogWarningText } from '../heavyLogGate';
import { useHeavyLogGate } from '../useHeavyLogGate';

interface TbcLogUrlPhaseProps {
    logUrlsText: string;
    loading: boolean;
    loadButtonLabel?: string;
    loadingLabel?: string;
    onLogUrlsChange: (value: string) => void;
    onLoadLogs: () => void;
    wclSnapshot?: WclProgressSnapshot | null;
}

const TbcLogUrlPhase: React.FC<TbcLogUrlPhaseProps> = ({
    logUrlsText,
    loading,
    loadButtonLabel = 'Load Logs',
    loadingLabel = 'Loading healers...',
    onLogUrlsChange,
    onLoadLogs,
    wclSnapshot,
}) => {
    const logCount = parseLogUrls(logUrlsText).length;
    const gate = useHeavyLogGate(logCount, onLoadLogs);
    const [pendingSingleUrl, setPendingSingleUrl] = useState<string | null>(null);

    // onLoadLogs reads the session's URL text, so wait for the pasted URL to land there first.
    useEffect(() => {
        if (pendingSingleUrl !== null && logUrlsText === pendingSingleUrl) {
            setPendingSingleUrl(null);
            onLoadLogs();
        }
    }, [pendingSingleUrl, logUrlsText, onLoadLogs]);

    return (
        <div className="url-phase">
            <div className="analyzer-form">
                <GuildLogPicker
                    disabled={loading}
                    onApplyUrls={(urls) => onLogUrlsChange(urls.join('\n'))}
                    onLoadSingleUrl={(url) => {
                        onLogUrlsChange(url);
                        setPendingSingleUrl(url);
                    }}
                />
                <HeavyLogWarning logCount={logCount} />
                <button
                    type="button"
                    onClick={gate.requestContinue}
                    disabled={loading || !logUrlsText.trim()}
                    className="process-button"
                >
                    {loading ? loadingLabel : loadButtonLabel}
                </button>
                {loading && <WclQueryProgress snapshot={wclSnapshot ?? null} />}
            </div>
            <ConfirmDialog
                open={gate.confirmOpen}
                title={`Load ${logCount} reports?`}
                message={heavyLogWarningText(logCount)}
                confirmLabel="Load anyway"
                onConfirm={gate.confirm}
                onCancel={gate.cancel}
            />
        </div>
    );
};

export default TbcLogUrlPhase;
